import React, { Component } from 'react';
import './Button.css';

class Button extends Component {
  render() {
    return (
      <div className = { "Button" + (this.props.disable ? " Disabled" : "") }>
        <button onClick = {this.props.disable ? null : this.props.onClick}>
          {this.props.label}
        </button>
      </div>
    );
  }
}

export default Button;



// WEBPACK FOOTER //
// ./src/ui/Button.js